document.addEventListener("DOMContentLoaded", function () {
  (function ($) {
    // Document Ready
    $(document).ready(function () {
      console.log("main.js initiated");

      // Initialize scripts
      initSiteScripts();

      // Add event listener for regular navigation
      $(document).on("click", 'a[href^="/"]:not([href^="#"]):not([target="_blank"])', function (e) {
        // Close menu if open
        $("body").removeClass("menu-open");
      });
    });

    // Function to initialize scripts
    function initSiteScripts() {
      console.log("Page Scripts Initialized");

      // Wait for Weglot to be defined before executing Weglot-specific code
      function weglotReady(callback) {
        if (typeof Weglot !== "undefined") {
          callback();
        } else {
          setTimeout(function () {
            weglotReady(callback);
          }, 100);
        }
      }

      weglotReady(function () {
        console.log("Weglot is ready");

        // Add event listener to update internal links for vacation subpages
        function updateVacationLinks() {
          const currentLang = Weglot.getCurrentLang(); // Get the current language
          $('a[href*="/vacation/"]').each(function () {
            const link = $(this);
            const href = link.attr("href");
            if (href && !href.includes(`/${currentLang}/`)) {
              const newHref = href.replace("/vacation/", `/${currentLang}/vacation/`);
              link.attr("href", newHref);
            }
          });
        }

        // Call the function on page load
        updateVacationLinks();

        // Handle language on direct URL visits
        const currentLang = Weglot.getCurrentLang();
        const pathname = window.location.pathname;
        if (!pathname.includes(`/${currentLang}/`) && pathname.includes("/vacation/")) {
          const newPath = pathname.replace("/vacation/", `/${currentLang}/vacation/`);
          window.location.pathname = newPath;
        }
      });

      var theScrollOutArgs = {
        // once: true,
        // cssProps: {
        //     visibleY: true
        // }
      };

      var inHeight = window.innerHeight / 100;
      var isMobile = window.matchMedia("only screen and (max-width: 1199px)").matches;

      /*****************************************************************
        Touch fix for devices to mimic hover effects
      ******************************************************************/
      $("*")
        .on("touchstart", function () {
          $(this).trigger("hover");
        })
        .on("touchend", function () {
          $(this).trigger("hover");
        });

      /*****************************************************************
        Opening & closing the various navigation menu buttons
      ******************************************************************/
      $("#menu-btn").click(function (event) {
        if ($("body").hasClass("menu-open")) {
          $(this).removeClass("active");
          $("body").removeClass("menu-open");
        } else {
          $(this).addClass("active");
          $("body").addClass("menu-open");
        }
      });

      // Toggle Mobile Sub Menus if has Children
      $(window).on("load", function () {
        if (isMobile) {
          var $subLink = $(".collapse > a"),
            $submenuLink = $(".collapse .sub-menu a");
          $subLink.attr("href", "javascript:void(0)");

          $subLink.on("click", function (e) {
            e.preventDefault();
            $(this).parent().toggleClass("sub-menu-open");
            $(this).next(".sub-menu").slideToggle(200);
          });

          $submenuLink.on("click", function (e) {
            $("#menu-btn").removeClass("active");
          });
        }
      });

      function updateBodyPush() {
        var headerHeight = $(".menu-container").outerHeight();
        var cruiseNavHeight = $(".cruise-nav").outerHeight() || 0; // Default to 0 if .cruise-nav doesn't exist
        document.documentElement.style.setProperty("--totalBodyPush", headerHeight + cruiseNavHeight + "px");
        document.documentElement.style.setProperty("--cruiseNavPush", headerHeight + "px");
        return headerHeight; // Return headerHeight for reuse
      }

      function handleScroll(headerHeight) {
        var cruiseNavHeight = $(".cruise-nav").outerHeight() || 0; // Default to 0 if .cruise-nav doesn't exist
        document.documentElement.style.setProperty("--totalBodyPush", headerHeight + cruiseNavHeight + "px");
        document.documentElement.style.setProperty("--cruiseNavPush", headerHeight + "px");

        if ($(window).scrollTop() > headerHeight) {
          $("body").addClass("fixed-show");
        } else {
          $("body").removeClass("fixed-show");
        }
      }

      function handleMobileClick() {
        $(".cruise-nav .meta-contain").on("click", function () {
          $(".cruise-nav .cruise-nav-contain").slideToggle(200);
          $(".cruise-nav .meta-contain").toggleClass("open-menu");
        });
      }

      var isCruiseNavExists = $(".cruise-nav").length > 0;
      var headerHeight = updateBodyPush();

      $(window).scroll(function () {
        handleScroll(headerHeight);
      });

      if (isCruiseNavExists && isMobile) {
        handleMobileClick();
      }

      ScrollOut(theScrollOutArgs).index();

      document.documentElement.style.setProperty("--vh", inHeight + "px");

      /*****************************************************************
        For when we do a img src="example.svg" SVG use instead of the 
        <svg> html markup
      ******************************************************************/

      $("img.svg").each(function () {
        var $img = $(this);
        var imgID = $img.attr("id");
        var imgClass = $img.attr("class");
        var imgURL = $img.attr("src");
        var dataFill = $img.attr("data-fill-color");
        var dataStroke = $img.attr("data-stroke-color");
        $.get(
          imgURL,
          function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find("svg"),
              $svgElements = $(data).find("svg *");
            // Add replaced image's ID to the new SVG
            if (typeof imgID !== "undefined") {
              $svg = $svg.attr("id", imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== "undefined") {
              $svg = $svg.attr("class", imgClass + " replaced-svg");
            }

            if ($img.parent(".svg-egg").length) {
              // console.log('Easter Egg.');
              $svgElements = $svgElements.removeAttr("stroke");
            }
            // Add Fill color of SVG
            if (typeof dataFill !== "undefined") {
              $svg = $svg.attr("fill", dataFill);
            }

            // Add Stroke color of SVG
            if (typeof dataStroke !== "undefined") {
              $svg = $svg.attr("stroke", dataStroke);
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr("xmlns:a");

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (!$svg.attr("viewBox") && $svg.attr("height") && $svg.attr("width")) {
              $svg.attr("viewBox", "0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
            }
            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          "xml"
        );
      });

      /*****************************************************************
       Accordions
      ******************************************************************/
      if ($("section.accordion").length) {
        $(".accordion-tab .top").click(function (event) {
          var parent = $(this).parent(".accordion-tab"),
            botOpen = $(parent).children(".bot"),
            botHeight = $(botOpen).children(".desc").outerHeight(true);

          if ($(parent).hasClass("open")) {
            $(parent).removeClass("open");
            $(botOpen).css("height", 0);
          } else {
            $(".accordion-tab").each(function (index, el) {
              var botReset = $(this).children(".bot");
              $(this).removeClass("open");
              $(botReset).css("height", "0");
            });

            $(parent).addClass("open");
            $(botOpen).css("height", botHeight);
          }
        });

        // In case they open a tab and then expand or shrink their screen
        $(window).resize(function (event) {
          if ($(".accordion-tab.open")) {
            var getBot = $(".accordion-tab.open").children(".bot");
            var newHeight = $(".accordion-tab.open").children(".bot").children(".desc").outerHeight(true);

            $(getBot).css("height", newHeight);
          }
        });
      }

      /*****************************************************************
       END Accordions
      ******************************************************************/

      /*****************************************************************
  Sliders used in global components
******************************************************************/
      // Function to get current language
      function getCurrentLanguage() {
        const url = window.location.href;
        if (url.includes("/es/")) {
          return "es";
        } else if (url.includes("/fr/")) {
          return "fr";
        } else if (url.includes("/de/")) {
          return "de";
        } else {
          return "en";
        }
      }

      const language = getCurrentLanguage();

      // Show the appropriate images based on the detected language
      $(".image-slider-section .slide").each(function () {
        const slide = this;
        $(slide)
          .find("img")
          .each(function () {
            const img = this;
            if ($(img).hasClass(language)) {
              $(img).css("display", "block");
            } else {
              $(img).css("display", "none");
            }
          });
      });

      // Function to initialize Owl Carousel
      function initializeOwlCarousel($slider) {
        var autoplay = $slider.hasClass("regular");
        $slider.owlCarousel({
          autoplay: autoplay,
          autoplayTimeout: 7500,
          autoplayHoverPause: true,
          nav: true,
          items: 1,
          singleItem: true,
          dots: true,
          loop: true,
          navText: [
            '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
            '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
          ],
          autoHeight: true,
        });
      }

      // Iterate through each slider section
      $(".image-slider-section .owl-carousel").each(function () {
        var $sliderSection = $(this);
        var $images = $sliderSection.find("img");
        var totalImages = $images.length;
        var imagesLoaded = 0;

        // Check if images are loaded
        $images.each(function () {
          $(this)
            .on("load", function () {
              imagesLoaded++;
              // Initialize carousel if all images are loaded
              if (imagesLoaded === totalImages) {
                initializeOwlCarousel($sliderSection);
              }
            })
            .each(function () {
              // Trigger load event if image is already loaded (for cached images)
              if (this.complete) {
                $(this).trigger("load");
              }
            });
        });

        // If there are no images, initialize
        if (totalImages === 0) {
          initializeOwlCarousel($sliderSection);
        }
      });
      /*****************************************************************
        END Sliders used in global components
      ******************************************************************/

      /*****************************************************************
        Cookie Handling
      ******************************************************************/

      function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = `${cname}=${cvalue};${expires};path=/;Secure;SameSite=Lax`;
      }

      /*****************************************************************
        END Cookie Handling
      ******************************************************************/

      /*****************************************************************
        Popup Handling
      ******************************************************************/

      function openModal() {
        $("body").addClass("modal-open");
      }

      function closeModal() {
        $("body").removeClass("modal-open");
        setCookie("waitClose", "closed", 120);
      }

      $("#wait-modal button.close-modal").click(function (e) {
        closeModal();
      });

      // Check if the current page is not the signup page before showing the modal
      const isSignupPage = window.location.pathname === "/signup" || window.location.pathname === "/signup/";
      if (getCookie("waitSubmit") != "submitted" && !isSignupPage) {
        console.log("Not on /signup page, checking for modal conditions...");
        if (getCookie("waitClose") != "closed") {
          setTimeout(function () {
            if (getCookie("waitSubmit") == "submitted" || getCookie("waitClose") == "closed") {
              console.log("Modal conditions not met, not opening modal.");
              return false;
            } else {
              console.log("Opening modal...");
              openModal();
            }
          }, 3000);
        }
      } else {
        console.log("On /signup page, modal will not open.");
      }

      $(".newsletter-form .gform_button").click(function (event) {
        setCookie("waitSubmit", "submitted", 120);
      });

      // Add event listener for clicking outside the modal
      $(document).on("click", function (e) {
        if (!$(e.target).closest("#wait-modal").length) {
          closeModal();
        }
      });

      /*****************************************************************
        END Popup Handling
      ******************************************************************/

      /*****************************************************************
        Form Submit Popup Handling
      ******************************************************************/

      function openModalTwo() {
        $("body").addClass("modal-open-form");
      }

      function closeModalTwo() {
        $("body").removeClass("modal-open-form");
      }

      $("#form-modal button.close-modal").click(function (e) {
        closeModalTwo();
      });

      var userEmail;

      function isValidEmail(email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }

      $("#gform_1, #gform_2").submit(function (e) {
        userEmail = $(this).find(".ginput_container_email > input").val();

        if (isValidEmail(userEmail)) {
          console.log(userEmail);
        } else {
          console.log("Invalid email address.");
          e.preventDefault(); // Prevent the form from submitting
        }
      });

      $(document).bind("gform_confirmation_loaded", function (event, form_id) {
        // Footer (ID 1) and Popup (ID 2) forms
        if (form_id == 1 || form_id == 2) {
          openModalTwo();
          $("#gform_5").find(".ginput_container_email > input").val(userEmail);
        }
      });

      /*****************************************************************
        END Popup Handling
      ******************************************************************/

      /*****************************************************************
        Animation Library / Area.

        Global Scroll Magic + GSAP
      ******************************************************************/

      // init scroll magic
      var smcontroller = new ScrollMagic.Controller();

      $(".fade-in-up").each(function () {
        var me = $(this);
        var showFromBot = new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 0.95,
        })
          .on("start", function (event) {
            $(me).addClass("show");
          })
          //.addIndicators()
          .addTo(smcontroller);
      });

      $(".fade-in-left").each(function () {
        var me = $(this);
        var showFromLeft = new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 0.95,
        })
          .on("start", function (event) {
            $(me).addClass("show");
          })
          //.addIndicators()
          .addTo(smcontroller);
      });

      $(".fade-in-right").each(function () {
        var me = $(this);
        var showFromRight = new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 0.95,
        })
          .on("start", function (event) {
            $(me).addClass("show");
          })
          //.addIndicators()
          .addTo(smcontroller);
      });

      $(".line-reveal").each(function () {
        var me = $(this);
        var lineReveal = new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 1,
        })
          .on("start", function (event) {
            $(me).addClass("show");
          })
          //.addIndicators()
          .addTo(smcontroller);
      });

      $(".scale-enter").each(function () {
        var me = $(this);
        var slideRevealLeft = new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 1,
        })
          .on("start", function (event) {
            $(me).addClass("unscale");
          })
          //.addIndicators()
          .addTo(smcontroller);
      });
      /*****************************************************************
        END Global Scroll Magic + GSAP
      ******************************************************************/

      /*****************************************************************
       * Video Modal Section
       *****************************************************************/
      var $videoModalSection = $(".video-modal-section");

      if ($videoModalSection.length) {
        function openModal() {
          var $thisSection = $(this).closest(".video-modal-section");
          var $correspondingModal = $thisSection.next(".video-modal");
          var $videoIframe = $correspondingModal.find("iframe");
          var videoSrc = $videoIframe.attr("src");

          $correspondingModal.addClass("modal-active");
          // Replace #swup selector with a more generic one like #main-content
          var $contentContainer = $("#swup").length ? $("#swup") : $("main");
          $contentContainer.css({ position: "relative", zIndex: "999" });
          $("body").css({ overflow: "hidden" });
          $videoIframe.attr("src", videoSrc + "?autoplay=1&loop=1&autopause=0");
        }

        function closeModal() {
          var $correspondingModal = $(this).closest(".video-modal");
          var $videoIframe = $correspondingModal.find("iframe");
          var videoSrc = $videoIframe.attr("src");

          // Remove any URL parameters
          videoSrc = videoSrc.split("?")[0];

          $correspondingModal.removeClass("modal-active");
          // Reset for both possible selectors
          $("#swup").css({ position: "", zIndex: "" });
          $("main").css({ position: "", zIndex: "" });
          $("body").css({ overflow: "" });
          $videoIframe.attr("src", videoSrc);
        }
        $(".video-modal-section .play-button").on("click", openModal);
        $(document).on("click touchstart", ".video-modal .close-button, .video-modal .overlay", closeModal);
      }

      /*****************************************************************
       * End Video Modal Section
       *****************************************************************/

      /*****************************************************************
       * Text Carousel Section
       *****************************************************************/

      setTimeout(function () {
        $(".text-carousel-section .owl-carousel").each(function () {
          var $slider = $(this);

          $slider.owlCarousel({
            autoplay: false,
            //autoplayTimeout: 8500,
            //autoplayHoverPause: true,
            nav: true,
            items: 1,
            singleItem: true,
            dots: true,
            loop: true,
            navText: [
              '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
              '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
            ],
            autoHeight: false,
          });

          $slider.on("change.owl.carousel", function () {
            $slider.trigger("stop.owl.autoplay");
            $slider.trigger("play.owl.autoplay");
          });
        });
      }, 100);
      /*****************************************************************
       * End Text Carousel Section
       *****************************************************************/

      /*****************************************************************
       Homepage – Toggle buttons for news and offers/vacations
      *****************************************************************/
      $(".toggle-btns .btn").click(function (e) {
        var tabs = $(".toggle-btns").children(),
          panels = $(".panel-container").children(),
          clickedTab = $(this),
          i = clickedTab.index(),
          newPanel = panels[i];

        tabs.removeClass("active");
        panels.removeClass("active");
        clickedTab.addClass("active");
        $(newPanel).addClass("active");
      });
      /*****************************************************************
       END – Toggle buttons for news and offers/vacations
      *****************************************************************/

      /*****************************************************************
       VACATION SINGLE
      *****************************************************************/
      if ($("main.single-vacation").length) {
        var smcontroller = new ScrollMagic.Controller();
        /*****************************************************************
          Vacation Single Page
        ******************************************************************/
        if ($(".itinerary-slider").length) {
          var $featbar = $(".itinerary-content .itinerary-slider");
          $featbar
            .owlCarousel({
              nav: true,
              items: 1,
              singleItem: true,
              margin: 40,
              rewind: true,
              rewindNav: true,
              rewindSpeed: 0,
              dots: false,
              loop: false,
              autoHeight: true,
              checkVisibility: true,
              // navContainer: ".nav-contain",
              navText: [
                '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
                '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
              ],
              responsive: {
                0: {
                  items: 1,
                },
                950: {
                  items: 1,
                  nav: true,
                  // autoHeight: false,
                },
              },
            })
            .on("changed.owl.carousel", function (event) {
              var current = event.item.index,
                allItems = $(".itinerary-content .stops .grouping").children().length,
                $navs = $(".itinerary-content .stops .grouping").children();

              // Fix for when the Owl Carousel has loop:true & clones .owl-items,
              // which messes up its index when goes from last to first.
              if (current > allItems || current == 0) {
                current = 0;
              }

              if (current < 0) {
                current = allItems - 1;
              }

              $($navs).removeClass("active");
              // $($imgs).removeClass("active");
              $($navs[current]).addClass("active");
              // $($imgs[current]).addClass("active");
            });

          $(".itinerary-content .stops .grouping .top").click(function (event) {
            var index = $(this).index();
            $featbar.trigger("to.owl.carousel", index);
          });

          $(window).on("resize", function () {
            $(".bar-info .owl-carousel .owl-stage-outer").width(innerWidth);
          });
        }

        /*****************************************************************
          Category pricing accordion
        ******************************************************************/
        $(".ship-category-heading").click(function () {
          var $this = $(this);
          var $details = $this.next(".ship-category-details");
          var $wrapper = $this.parent(".ship-category");

          if ($wrapper.hasClass("is-open")) {
            $details.stop().slideUp();
            $wrapper.removeClass("is-open");
          } else {
            $details.stop().slideDown();
            $wrapper.addClass("is-open");
          }
        });

        // Clicking the Reserve Now button shouldn't toggle the accordion
        $(".ship-category-heading .btn").click(function (e) {
          e.stopPropagation();
        });

        // On page load, we want to open the first category
        // of every group that isn't sold out
        $(".room-group-heading").each(function () {
          $(this)
            .nextUntil(".room-group-heading")
            .each(function () {
              if (!$(".btn.is-sold_out", this).length) {
                $(this).addClass("is-open");
                $(".ship-category-details", this).show();
                return false;
              }
            });
        });

        /*****************************************************************
          Category pricing page
        ******************************************************************/
        // the room & floorplan slider
        var $roomCategoryImages = $(".ship-category-details .images");
        $roomCategoryImages.each(function (index, el) {
          $(el).owlCarousel({
            items: 1,
            singleItem: true,
            rewind: true,
            rewindNav: true,
            rewindSpeed: 0,
            nav: true,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            navText: [
              '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
              '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
            ],
          });
        });

        // Actual Deck slide-out modal creation as a slider
        var $deckSelect = $("#deckplan-select");
        var $deckplans = $(".deckplan-container");
        var $allDecks = $($deckplans).children();

        // the <select> dropdown above the Deckplans
        $deckSelect.on("change", function () {
          var selectedDeck = $(this).val();
          $($allDecks).removeClass("active");
          $($allDecks[selectedDeck]).addClass("active");
        });

        // when a deckplan is clicked from the pricing room categories
        var $deckModal = $(".modal--deckplans");
        $(".js-modal-deckplans").click(function (e) {
          e.preventDefault();
          $deckModal.toggleClass("is-open");
          $("body").toggleClass("deckplans-open");
          //$deckSlider.flickity( 'resize' );

          var deck = $(this).data("deck");
          if (deck) {
            var selectOptions = $($deckSelect).children();

            $(selectOptions).each(function (index, el) {
              var temp1 = $(this).data("deck");
              var temp2 = $(this).val();

              if (temp1 == deck) {
                $deckSelect.val(temp2);
                $($allDecks).removeClass("active");
                $($allDecks[temp2]).addClass("active");
              }
            });
          }
        });

        // closing the deckplan modal
        $(".the-modal button.close").click(function (e) {
          e.preventDefault();
          $(".the-modal").removeClass("is-open");
          $("body").removeClass("deckplans-open");
        });

        $(".the-modal .modal-window").click(function (e) {
          e.stopPropagation();
        });
        $(".the-modal").click(function (e) {
          $(this).removeClass("is-open");
          $("body").removeClass("deckplans-open");
        });
        /*****************************************************************
          END Category pricing page
        ******************************************************************/
      }
      /*****************************************************************
       END – VACATION SINGLE
      *****************************************************************/

      /*****************************************************************
       Sepcial Code for Weglot Plugin
      *****************************************************************/
      var menuBtn1 = $(".call-cta").outerWidth();
      var menuBtn2 = $(".main-cta").outerWidth();
      document.documentElement.style.setProperty("--rightpush", menuBtn1 + menuBtn2 + "px");
      $(window).resize(function (event) {
        document.documentElement.style.setProperty("--rightpush", menuBtn1 + menuBtn2 + "px");
      });
      /*****************************************************************
       END – Sepcial Code for Weglot Plugin
      *****************************************************************/

      /*****************************************************************
       Countdown Timer
      *****************************************************************/
      if ($(".countdown-timer-section").length) {
        // Get the countdown date from the data attribute
        const countdownElement = document.querySelector(".countdown-wrap");
        const countdownDateStr = countdownElement.getAttribute("data-countdown");

        console.log("Raw countdown date string:", countdownDateStr); // Debug log

        if (!countdownDateStr) {
          console.error("No countdown date found in data-countdown attribute");
          return;
        }

        try {
          // Parse the date string and convert to LA timezone
          const parts = countdownDateStr.split(" ");

          if (parts.length < 3) {
            throw new Error(
              `Invalid date format. Got ${parts.length} parts, expected at least 3. Full string: ${countdownDateStr}`
            );
          }

          const datePart = parts[0];
          const timePart = parts[1];
          const period = parts[2];

          const [day, month, year] = datePart.split("/");
          const [hoursStr, minutesStr] = timePart.split(":");

          console.log("Parsed components:", {
            day,
            month,
            year,
            hoursStr,
            minutesStr,
            period,
          }); // Debug log

          if (!day || !month || !year || !hoursStr || !minutesStr || !period) {
            throw new Error(
              `Missing required date components. Got: ${JSON.stringify({
                day,
                month,
                year,
                hoursStr,
                minutesStr,
                period,
              })}`
            );
          }

          // Create date string in ISO format for LA timezone
          // For 12 PM, we want 12:00, not 24:00
          const parsedHours = period.toLowerCase() === "pm" && hoursStr !== "12" ? parseInt(hoursStr) + 12 : parseInt(hoursStr);

          // Create ISO string with LA timezone (-07:00 for PDT)
          const dateString = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${parsedHours
            .toString()
            .padStart(2, "0")}:${minutesStr}:00-07:00`;
          const countdown = new Date(dateString);

          console.log("Final countdown date:", countdown); // Debug log
          console.log("ISO string used:", dateString); // Debug log

          const days = document.querySelector(".days").querySelector(".flip-card");
          const hours = document.querySelector(".hours").querySelector(".flip-card");
          const minutes = document.querySelector(".minutes").querySelector(".flip-card");
          const seconds = document.querySelector(".seconds").querySelector(".flip-card");

          // ** get the time totals, return them
          function getTimeRemaining(countdown) {
            const now = new Date();
            const diff = countdown - now;

            // If countdown has ended, return all zeros
            if (diff <= 0) {
              return {
                diff: 0,
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
              };
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / 1000 / 60) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            return {
              diff,
              days,
              hours,
              minutes,
              seconds,
            };
          }

          function initializeClock(countdown) {
            function updateClock() {
              const t = getTimeRemaining(countdown);

              // Only animate if we haven't reached zero
              if (t.diff > 0) {
                addFlip(days, t.days);
                addFlip(hours, t.hours);
                addFlip(minutes, t.minutes);
                addFlip(seconds, t.seconds);
              } else {
                // Set all values to 0 without animation
                days.querySelector(".top-half").innerText = "00";
                days.querySelector(".bottom-half").innerText = "00";
                hours.querySelector(".top-half").innerText = "00";
                hours.querySelector(".bottom-half").innerText = "00";
                minutes.querySelector(".top-half").innerText = "00";
                minutes.querySelector(".bottom-half").innerText = "00";
                seconds.querySelector(".top-half").innerText = "00";
                seconds.querySelector(".bottom-half").innerText = "00";
              }

              if (t.diff <= 0) {
                clearInterval(timeinterval);
              }
            }

            updateClock();
            const timeinterval = setInterval(updateClock, 1000);
          }

          const addFlip = (card, time) => {
            // ** confirm time has changed
            const currTime = card.querySelector(".top-half").innerText;
            if (time == currTime) return;

            let t = time <= 9 ? `0${time}` : time;
            const topHalf = card.querySelector(".top-half");
            const bottomHalf = card.querySelector(".bottom-half");
            const topFlip = document.createElement("div");
            const bottomFlip = document.createElement("div");

            // ** add animation, populate with current time
            topFlip.classList.add("top-flip");
            topFlip.innerText = currTime;

            bottomFlip.classList.add("bottom-flip");

            // ** animation begins, update top-half to new time
            topFlip.addEventListener("animationstart", () => {
              topHalf.innerText = t;
            });

            // ** animation ends, remove animated div, update bottom animation to new time
            topFlip.addEventListener("animationend", () => {
              topFlip.remove();
              bottomFlip.innerText = t;
            });

            // ** animation ends, update bottom-half to new time, remove animated div
            bottomFlip.addEventListener("animationend", () => {
              bottomHalf.innerText = t;
              bottomFlip.remove();
            });

            card.appendChild(topFlip);
            card.appendChild(bottomFlip);
          };

          initializeClock(countdown);
        } catch (error) {
          console.error("Error initializing countdown timer:", error);
        }
      }
      /*****************************************************************
       END – Countdown Timer
      *****************************************************************/
    }
  })(jQuery);
});
